import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import FromCovic from "../wms/formCovid";
import { Button } from "reactstrap";
import FormCovid from "../wms/formCovid";

const Modalcovic = ({ header, onSelect ,isOpen,onCancel,search='',list  }) => {
  const [openModalcovic, setOpenModalcovic] = useState(false);
  function handleUpdateData(value) {
    onCancel(value);

  }
  const handleCanclecovic = () => {
    setOpenModalcovic(false);   
  };
  return (
    <>
    
        <Modal
          show={isOpen}
          onHide={onCancel}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">       
                        <h2 style={{ color: 'red' }}>กรุณาประเมิน Covid-19</h2>
                       
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
           
              <FormCovid
              onCancel ={handleUpdateData}
              list ={list}
              /> 
          </Modal.Body>
          <Modal.Footer>
           
          </Modal.Footer>
        </Modal>
     
    </>
  );
};

export default Modalcovic;
